/* global __IS_SERVER__ */
var isServer = typeof __IS_SERVER__ !== 'undefined' && __IS_SERVER__;

export const canUseDOM =
    !isServer &&
    !!(typeof window !== 'undefined' && window.document && window.document.createElement);
